
import React from 'react';
import { Modal } from 'reactstrap';

const SaveHierarchyModal = ({ 
        isOpenHierarchy, 
        toggleHierarchy, 
        onSubmitOnlyProgram, 
        onSubmitHierarchy, 
    }) => {

    return (
        <Modal
            className="manager-program-settings-dialog modal-md"
            isOpen={isOpenHierarchy}
            toggle={toggleHierarchy}
            centered
        >
            <div className="manager-program-settings-dialog__header">
                <div className="manager-program-settings-dialog__header-copy">
                    <h4 className="manager-program-settings-dialog__title">Save across hierarchy?</h4>
                    <p className="manager-program-settings-dialog__description">
                        Choose whether this event should stay in the current program only or be copied across the hierarchy.
                    </p>
                </div>
                <button
                    type="button"
                    className="manager-program-settings-dialog__close"
                    onClick={toggleHierarchy}
                    aria-label="Close"
                >
                    Close
                </button>
            </div>
            <div className="manager-program-settings-dialog__body">
                <div className="manager-program-settings-dialog__actions">
                    <button
                        type="button"
                        className="manager-program-settings-dialog__action"
                        onClick={onSubmitOnlyProgram}
                    >
                        Current program only
                    </button>
                    <button
                        type="button"
                        className="manager-program-settings-dialog__action is-primary"
                        onClick={onSubmitHierarchy}
                    >
                        Save to hierarchy
                    </button>
                    <button
                        type="button"
                        className="manager-program-settings-dialog__action"
                        onClick={toggleHierarchy}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default SaveHierarchyModal;
